import { useState } from 'react'

// Presets are page-owned filter config. They are deliberately NEVER written
// to the ?filter= URL param (that stays user-filters-only): edits to editable
// presets reset to the developer defaults on reload, and shared links carry
// only the user's own filters -- the recipient's page re-applies its own
// presets. See the batch-1 design spec.
export function usePresetFilters(presetConfig) {
    const [presets, setPresets] = useState(() => (presetConfig || []).map((preset, index) => ({
        id: `preset-${index}`,
        fieldName: preset.fieldName,
        filterType: preset.filterType,
        filterValues: preset.filterValues !== undefined ? preset.filterValues : null,
        editable: !!preset.editable,
        visible: preset.visible !== false,
    })))
    return [presets, setPresets]
}

// The single FilterInput[] a page sends as the GraphQL `filters` variable.
export function combineFilters(presets, urlFilters) {
    return [
        ...(presets || []).map(({ fieldName, filterType, filterValues }) => ({ fieldName, filterType, filterValues })),
        ...(urlFilters || []),
    ]
}

// Header badges count what the user can SEE: visible presets + user filters.
export function countVisibleFilters(presets, urlFilters) {
    return (presets || []).filter((p) => p.visible !== false).length + (urlFilters || []).length
}
